import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ROLES } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function RoleSelect() {
  const { user, setUser } = useAuth();
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!user) navigate("/login", { replace: true });
    else if (user.role_selected) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const save = async () => {
    if (!selected) return;
    setSaving(true);
    try {
      const { data } = await api.post("/auth/select-role", { role: selected });
      setUser(data);
      toast.success("Role selected");
      navigate("/dashboard", { replace: true });
    } catch (e) {
      toast.error("Could not save role");
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--adn-cream)]">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <p className="eyebrow">Welcome to ADN</p>
        <h1 className="font-display text-4xl font-semibold mt-2">Which best describes you?</h1>
        <p className="text-[var(--adn-text-soft)] mt-3">Choose one to set up your dashboard. You can change this later from your profile.</p>

        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          {ROLES.map((r) => (
            <button
              key={r.id}
              data-testid={`role-${r.id}`}
              onClick={() => setSelected(r.id)}
              className={`text-left bg-white border ${selected === r.id ? "border-[var(--adn-gold)] shadow-md" : "border-[var(--adn-line)]"} p-5 hover:border-[var(--adn-navy)] transition-colors`}
            >
              <div className="font-display font-semibold text-[17px]">{r.label}</div>
              <div className="text-sm text-[var(--adn-text-soft)] mt-1">{r.desc}</div>
            </button>
          ))}
        </div>

        <div className="mt-8 flex gap-3">
          <button
            data-testid="role-continue"
            disabled={!selected || saving}
            onClick={save}
            className="btn-gold px-7 py-3 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? "Saving…" : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
}
